module.exports = __webpack_public_path__ + "static/media/Larry.bbef1595.jpg";